<template>
    <div class="form-group">
        <label :for="named" v-if="label" class="control-label">{{ trans(label) }}</label>
        <select :id="named" v-model="value" :name="named" class="form-control" v-on:change="updateValue($event.target.value)">
            <option v-if="default_msg.length > 0" :value="default_val">{{ default_msg }}</option>
            <option v-for="(val, key, index) in list" :value="va(val, key)" :selected="selected(val, key)">{{ val }}</option>
        </select>
    </div>
</template>
<script>
    export default{
        props: {
            id: { default: '' },
            usekey: { default: false },
            label: { default: false },
            name: { default: '' },
            list: { default: [] },
            value: { default: 1 },
            default_msg: { default: '--- Please Select ---' },
            default_val: { default: '' }
        },
        computed: {
            named: function () {
                // Compute name depending on how deep it should be
                if (this.name == '') return this.id;
                return this.name + '[' +  this.id + ']';
            }
        },
        methods: {
            selected(val, key) {
                return ((this.usekey && this.value == key) || (!this.usekey && this.value == val));
            },
            va: function (val, key) {
                return (this.usekey) ? key : val;
            },
            updateValue: function (value) {
                this.$emit('input', value);
            }
        }
    }
</script>
